export const validateCartStock = async (items) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/products/validate-cart`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  });

  if (!response.ok) {
    throw new Error('No se pudo verificar el stock disponible');
  }

  return response.json();
};

export const getStockIssueMessage = (issues = []) => {
  const names = [...new Set(issues.map((issue) => {
    const variant = issue.variant ? ` (${issue.variant})` : '';
    return `${issue.name}${variant}`;
  }))];

  if (!names.length) return 'Uno o más productos ya no están disponibles.';
  if (names.length === 1) return `${names[0]} ya no tiene stock disponible. Quitalo o ajustá su cantidad para continuar.`;
  return `${names.join(', ')} ya no tienen stock disponible. Quitalos o ajustá sus cantidades para continuar.`;
};

export const getStockLimit = (result, productId, selectedVariant) => result.items?.find((item) => (
  item.productId === productId?.toString() &&
  (!selectedVariant?.variantId || item.variantId === selectedVariant.variantId?.toString())
))?.available;
